import {XauditModel} from '../xaudit.model';
import {PatientCaseEndoFinalReportReferrRepDataModel} from './patient-case-endo-final-report-referr-rep-data.model';
import {PatientCaseEndoFinalReportRestorRecomdDataModel} from './patient-case-endo-final-report-restor-recomd-data.model';

export class PatientCaseEndoFinalReportDataModel extends XauditModel {
  CaseFinalReportID: string;
  PatientCaseId: string;
  isReportNeede: boolean = true;
  enumFinalReportCaseStatusID: string;
  enumFinalReportPrognosisID: string;
  CompletedDate: Date;
  enumCaseTypeID: string;
  enumFinalReportRecallID: string;
  RecallDate: Date;
  isSuperRecall: boolean;
  RefereToDoctorID: string;
  RefereToGPDoctorID: string;
  enumTreatmentSessionsID: string;
  enumCaseRatingID: string;
  isAsumptomaticeAtTimeOfFill: boolean;
  isMutiplePOE: boolean;
  isLateralRootFurPOE: boolean;
  isSendDiagnostics: boolean;
  isDiagnosticsLarge: boolean;
  NoteID: string;
  TretmentTime: Date;
  QValue: number;
  Pvalue: number;
  Note: string;
  caseWorkItemFormsId: string;
  caseWorkItemID: string;

  dataPatientCaseEndoFinalReportReferrReps: PatientCaseEndoFinalReportReferrRepDataModel[] = [];
  dataPatientCaseEndoFinalReportRestorRecomds: PatientCaseEndoFinalReportRestorRecomdDataModel[] = [];
}
